'use strict';

import angular from 'angular';

export default class joinCtrl {
  static get UID() {
    return 'joinCtrl';
  }

  constructor($scope, $window, joinFac) {
    Object.assign(this, { $scope, $window, joinFac });

    this.selectedProcessor = 1;
    this.selectedType;
    this.typeOptions;
    this.selectedOpt;

    this.$scope.$watch('this.selectedType', (newVal, oldVal) => {
      if( newVal === oldVal  ||
          newVal === undefined ||
          !this.billingProcessors )
        return;


      this.typeOptions = this.billingProcessors[this.selectedProcessor].billingOptions[this.selectedType];
      this.selectedOpt = this.typeOptions[0];
      console.log("Setting type options", this.typeOptions);
    });

    this.joinFac.getOptions()
      .then((response) => {
        this.billingProcessors = response.data.data

        if( !this.billingProcessors ) {
          return;
        }

        this.selectedType = 'credit';

        // set the default typeOptions
        this.typeOptions = this.billingProcessors[this.selectedProcessor].billingOptions[this.selectedType];

        // default to the first option
        this.selectedOpt = Array.isArray(this.typeOptions) && this.typeOptions.length > 0 ? this.typeOptions[0] : undefined;
      });
  }

  submitJoinForm(processorKey) {
    var processor = this.billingProcessors[processorKey];

    var url = processor.post_url;
    
    var firstUrlParam = true;
    angular.forEach(processor.formFields.all,
      function(value, key) {
        if (firstUrlParam) {
          url += "?";
          firstUrlParam = false;
        }
        else {
          url += "&";
        }

        url += value.name + "=" + encodeURIComponent(value.value);
      });

    angular.forEach(processor.formFields[this.selectedType],
      function(value, key) {
        url += "&" + value.name + "=" + encodeURIComponent(value.value);
      });

    if (processor.name == 'CCBill') {
      url += "&subscriptionTypeId=" + encodeURIComponent(this.selectedOpt.processorOptionId);


      var firstAllowedType = true;
      angular.forEach(processor.billingOptions[this.selectedType],
        function(value, key) {
          if (firstAllowedType) {
            url += "&allowedTypes=" + encodeURIComponent(value.processorOptionId);
            firstAllowedType = false;
          }
          else {
            url += "," + encodeURIComponent(value.processorOptionId);
          }
        });
    }

    this.$window.location.href = url;
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/join/joinCtrl.js